import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router does not restore scroll position or honour #hash targets on
 * navigation. Without this, following a link from the bottom of the landing
 * page drops you into the middle of the next one, and every
 * /privacy-policy#section link landed at the top of the page instead.
 */
export default function ScrollManager() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            return;
        }

        // Sections animate in, so the target may not exist on the first frame.
        // Poll briefly rather than giving up immediately.
        const id = hash.slice(1);
        let frames = 0;
        let raf = 0;
        const tryScroll = () => {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ block: "start", behavior: "auto" });
                return;
            }
            if (frames++ < 60) raf = requestAnimationFrame(tryScroll);
        };
        raf = requestAnimationFrame(tryScroll);
        return () => cancelAnimationFrame(raf);
    }, [pathname, hash]);

    return null;
}
